import asyncLoadJs from './asyncLoadJs';

export default () => {
  var http =
    '//sdk.talkingdata.com/app/h5/v1?appid=0CC10A8C43E345608B12FCB5125AF323';
  var https =
    '//jic.talkingdata.com/app/h5/v1?appid=0CC10A8C43E345608B12FCB5125AF323';
  var script = /https/.test(window.location.protocol) ? https : http;
  var vn = 'web';
  var vc = 1.0;
  return asyncLoadJs(`${script}&vn=${vn}&vc=${vc}`);
};
